import { Component, h, Prop, State, Listen } from '@stencil/core';
import URLS from '../app-root/urls';

@Component({
  tag: 'app-contact-us',
  styleUrl: 'style.scss',
  shadow: false,
  scoped: false
})
export class AppContactUs {
  @Prop() showFormModal: boolean = false;
  @State() showModal: boolean = false;
  @Listen('closeModalEvent')
  closeModalHandler() {
    this.showModal = false;
  }

  openModaldHandler() {
    this.showModal = true;
  }

  render() {
    return (
      <div class='zento-marketing-box-wrapper'>
        <div class='zento-marketing-box-inner'>
          <div class='zento-marketing-box align-center'>
            <h2 class='subtitle'>Chcesz wiedzieć więcej?</h2>
            {
              this.showFormModal ?
              <div class='showFormModal'>
                <span
                  class='item-link'
                  onClick={ this.openModaldHandler.bind(this) }
                >
                  Skontaktuj się
                </span>
                <app-modal
                  showModal={ this.showModal }
                >
                  <app-contact-form />
                </app-modal>
              </div> :
              !this.showFormModal ?
              <stencil-route-link class='item' url={URLS.AppContactPage}>
                <span class='item-link'>
                  Skontaktuj się
                </span>
              </stencil-route-link> :
              null
            }
          </div>
        </div>
      </div>
    );
  }
}
